import Faq from '../../views/Faq';
import Account from '../../views/MonProfil';
import pages from '../pages';
import { Route } from '../routes';

export const settingRoutes: Route[] = [
  {
    path: pages.MY_ACCOUNT.path,
    component: Account
  },
  {
    path: pages.FAQ_PAGE.path,
    component: Faq
  }
];
